import { registerLocaleData } from "@angular/common";
import localeDECH from "@angular/common/locales/de-CH";
import { enableProdMode, importProvidersFrom, inject, LOCALE_ID, provideAppInitializer } from "@angular/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideRouter, RouteReuseStrategy, withComponentInputBinding, withPreloading, withRouterConfig } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { EffectsModule } from "@ngrx/effects";
import { NavigationActionTiming, routerReducer, StoreRouterConnectingModule } from "@ngrx/router-store";
import { Store, StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";

import { CookieService } from "ngx-cookie-service";
import { ngxLoadingAnimationTypes, NgxLoadingModule } from "ngx-loading";

import { API_URL, ToastServiceToken } from "#src/core/backend/controller-bare.service";

import { SESSION_STORAGE_PREFIX } from "#modules/search/tokens";
import { ToastService } from "#modules/shared/services/toast.service";
import { SharedModule } from "#modules/shared/shared.module";
import { PublicationsEffects, PublicationsStore } from "#modules/store/publications";

import { environment } from "./environments/environment";
import { AppPreloadingStrategy } from "./modules/app/app-preloading-strategy";
import { routes } from "./modules/app/app-routing.module";
import { CacheRouteReuseStrategy } from "./modules/app/cache-route-reuse.strategy";
import { AppComponent } from "./modules/app/components/app/app.component";

if (environment.production) {
  enableProdMode();
}

function getApiUrl() {
  return document.getElementsByTagName("base")[0].href + "api";
}

registerLocaleData(localeDECH);

document.addEventListener("DOMContentLoaded", () => {
  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(
        routes,
        withPreloading(AppPreloadingStrategy),
        withRouterConfig({ paramsInheritanceStrategy: "always" }),
        withComponentInputBinding()
      ),
      provideAppInitializer(() => {
        inject(Store).dispatch(PublicationsStore.Action.Load.request());
      }),
      AppPreloadingStrategy,
      importProvidersFrom(
        BrowserModule,
        SharedModule.forRoot(),
        // NgLoadersModule.forRoot({
        //     color: "var(--mat-sys-primary)",
        //     type: NgLoadersTypes.GROWING_CIRCLE,
        // }),
        NgxLoadingModule.forRoot({
          animationType: ngxLoadingAnimationTypes.doubleBounce,
          backdropBackgroundColour: "rgba(0,0,0,0.1)",
          primaryColour: "var(--mat-sys-primary)",
          secondaryColour: "var(--mat-sys-primary)",
          tertiaryColour: "var(--mat-sys-primary)",
          backdropBorderRadius: "4px",
        }),
        ServiceWorkerModule.register("ngsw-worker.js", { enabled: environment.production }),
        //
        StoreModule.forRoot({ router: routerReducer, publications: PublicationsStore.reducer }),
        EffectsModule.forRoot([PublicationsEffects]),
        StoreRouterConnectingModule.forRoot({ navigationActionTiming: NavigationActionTiming.PostActivation }),
        ...(environment.production ? [] : [StoreDevtoolsModule.instrument({ maxAge: 25 })])
      ),
      { provide: LOCALE_ID, useValue: "de-CH" },
      { provide: SESSION_STORAGE_PREFIX, useValue: "main-" },
      { provide: API_URL, useFactory: getApiUrl },
      { provide: RouteReuseStrategy, useClass: CacheRouteReuseStrategy },
      { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: "outline" } },
      { provide: ToastServiceToken, useClass: ToastService },
      CookieService,
    ],
  })
    .then(() => {
      if ("serviceWorker" in navigator && environment.production) {
        navigator.serviceWorker.register("./ngsw-worker.js");
      }
    })
    .catch((err) => console!.error(err));
});
